var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTutorial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9121 10.62C17.0226 10.6839 17.1143 10.7758 17.1781 10.8863C17.2419 10.9969 17.2754 11.1223 17.2754 11.25C17.2754 11.3776 17.2419 11.503 17.1781 11.6136C17.1143 11.7242 17.0226 11.816 16.9121 11.88L12.339 14.526C12.2286 14.5899 12.1032 14.6235 11.9756 14.6235C11.848 14.6235 11.7227 14.5899 11.6123 14.526C11.5018 14.4621 11.4102 14.3702 11.3466 14.2596C11.283 14.149 11.2497 14.0236 11.25 13.896V8.60397C11.2498 8.47654 11.2831 8.3513 11.3467 8.24085C11.4102 8.1304 11.5017 8.03863 11.612 7.97477C11.7223 7.91091 11.8474 7.87722 11.9748 7.87708C12.1022 7.87693 12.2275 7.91035 12.3379 7.97397L16.9121 10.62Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 23.625H19.125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 3.375H4.5C3.25736 3.375 2.25 4.38236 2.25 5.625V16.875C2.25 18.1176 3.25736 19.125 4.5 19.125H22.5C23.7426 19.125 24.75 18.1176 24.75 16.875V5.625C24.75 4.38236 23.7426 3.375 22.5 3.375Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.8e421a7f69c53a7e9180435a103b42bb.svg";
export { ForwardRef as ReactComponent };